import "./index.css";

import { useState, useEffect } from "react";
import React from "react";

const ChatInput = ({ disabled, value, setValue, handleSubmit }) => {
  const [showInput, setShowInput] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const examplePrompts = [
    `"Breakfast: banana and 3 eggs"`,
    `"Design a 45-minute upper body workout"`,
    `"Calculate my TDEE?"`,
    `"Create a 3-day vegetarian meal plan"`,
    `"What's the best way to lose weight?"`,
    `"What's the best way to gain muscle?"`, 
    `"Dinner: Steak bowl from Chipotle, 2x meat"`,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((currentIndex + 1) % examplePrompts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex, examplePrompts.length]);

  const openModal = () => {
    setShowModal(!showModal);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <div
        className={`chat-input ${showInput ? "active" : ""} ${
          disabled ? "disabled" : ""
        }`}
      >
        <div className="chat-input-container radius">
          <div className="chat-input-circle radius">
            <form className="chat-input-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Hey Hyper..."
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="chat-text-input radius"
                onFocus={() => setShowInput(true)}
                onBlur={() => setShowInput(false)}
              />
              <button type="submit" className="chat-submit-button">
                <i className="fa fa-paper-plane" />
              </button>
            </form>
          </div>
        </div>
        <div className="instruction-text" onClick={openModal}>
          Hyper v0.1 &mdash; Example prompts
          <i className={`fa fa-angle-${showModal ? "up" : "down"}`} />
        </div>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="example-prompts">
              <div>{examplePrompts[currentIndex]}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatInput;
